const GroupExclamationIcon = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 1.5C50.397 1.5 64.5 15.603 64.5 33C64.5 50.397 50.397 64.5 33 64.5C15.603 64.5 1.5 50.397 1.5 33C1.5 15.603 15.603 1.5 33 1.5Z"
        fill="#FFFCF3"
        stroke="#F0B323"
        stroke-width="3"
      />
      <path
        d="M36.3992 19.8C36.3992 17.9775 34.9177 16.5 33.0902 16.5C31.2627 16.5 29.7812 17.9775 29.7812 19.8V39.6C29.7812 41.4225 31.2627 42.9 33.0902 42.9C34.9177 42.9 36.3992 41.4225 36.3992 39.6V19.8Z"
        fill="#F0B323"
      />
      <path
        d="M36.3992 49.4992C36.3992 47.6767 34.9177 46.1992 33.0902 46.1992C31.2627 46.1992 29.7812 47.6767 29.7812 49.4992C29.7812 51.3218 31.2627 52.7992 33.0902 52.7992C34.9177 52.7992 36.3992 51.3218 36.3992 49.4992Z"
        fill="#F0B323"
      />
</svg>
  )
}

export { GroupExclamationIcon }

